import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";
import type { CustomerMemoryConsentStatus } from "@/types/voice/customer-memory";

export const useCustomerMemoryConsent = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ genieId, enabled }: { genieId: string; enabled: boolean }) =>
      ApiService.invoke<{ memoryConsent: CustomerMemoryConsentStatus }>({
        resource: "genies",
        action: "update-memory-consent",
        data: { genieId, enabled },
      }),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["agent-page-by-url"] }),
        queryClient.invalidateQueries({ queryKey: ["agent-page-by-url-full"] }),
      ]),
  });
};
